import { Component } from "@angular/core";
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-image-formatter-cell',
  template: `<img width="47" height="47" style="padding: 4px; object-fit: contain;" src=\"{{ params.value }}\">`
})

export class ImageRenderer implements ICellRendererAngularComp{
  params: any;


  agInit(params: any): void {
    this.params = params;
    if(this.params.value == null){
      this.params.value = "assets/img/placeholder.svg"
    }
  }


  refresh(): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ag-grid-custom-components/image-renderer.ts